import React, {useState} from "react";
import Banner from "./Banner/Banner";
import NftCard from "../../GlobalComponents/NftCard/NftCard";
import thum from "../Marketplace/Banner/assets/thum.png";
import thum2 from "../Marketplace/Banner/assets/thum2.png";
import NavLayout from "../../GlobalComponents/NavLayout/NavLayout";

import ProfileNftCard from "./ProfileNftCard/ProfileNftCard";
import { publicNav } from "../../utils/navItems";
import ConnectButton from "../../GlobalComponents/ConnectButton/ConnectButton";
import Faq from "../../GlobalComponents/Faq/Faq";
import Footer from "../../GlobalComponents/Footer/Footer";
const data = [
  { thum, gold: false },
  { thum: thum2, gold: true },
  { thum, gold: false },
  { thum: thum2, gold: true },
  { thum, gold: false },
  { thum: thum2, gold: true },
  { thum, gold: false },
  { thum: thum2, gold: true },
  { thum, gold: false },
  { thum: thum2, gold: true },
  { thum, gold: false },
  { thum: thum2, gold: true },
  { thum, gold: false },
  { thum: thum2, gold: true },
  { thum, gold: false },
  { thum: thum2, gold: true },
];
const MyProfile = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [address, setAddress] = useState("");
  return (
    <div>
      <NavLayout
        navItems={publicNav}
        setAddress={setAddress}
        bold={true}
        buttons={
          <div className="button-container">
            <ConnectButton></ConnectButton>
          </div>
        }
      ></NavLayout>
      <div className="mt-[50px] text-center md:mt-[87px]">
        <h2 className="text-xl font-bold">My Profile</h2>
      </div>
      <div className="max-w-[1410px] mx-auto">
        <Banner
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
        ></Banner>
        <div className="mt-[39px] pb-[342px]">
          <div className="flex flex-wrap gap-[30px] justify-center">
            {activeIndex === 0
              ? data.map((single, i) => (
                  <ProfileNftCard key={i} {...single}></ProfileNftCard>
                ))
              : activeIndex === 1
              ? data
                  .filter((single) => !single.gold)
                  .map((single, i) => (
                    <ProfileNftCard key={i} {...single}></ProfileNftCard>
                  ))
              : data
                  .filter((single) => single.gold)
                  .map((single, i) => (
                    <ProfileNftCard key={i} {...single}></ProfileNftCard>
                  ))}
          </div>
        </div>
      </div>
      <div className="mt-10">
        <Footer></Footer>
      </div>
    </div>
  );
};

export default MyProfile;
